export default {
  title: "Подбор по условиям",
  hint: "Выберите задачу или соберите связи вручную. Список можно скачать как CSV или JSON.",
  find: "Найти",
  reset: "Сбросить условия",
  chooseScenario: "Что нужно найти?",
  chooseScenarioHint: "Готовая задача каталога или свой набор связей между записями.",
  builderTitle: "Собрать связи вручную",
  builderHint: "Составьте условия, выбирая типы записей и связи между ними — без текста запроса.",
  builderLoading: "Загрузка конструктора…",
  configError: "Не удалось загрузить конструктор. Можно составить запрос текстом SPARQL ниже.",
  sparql: "SPARQL",
  sparqlSummary: "Текст запроса (SPARQL)",
  sparqlHint: "Для специалистов. Сервер принимает SELECT и ASK, не больше 1000 строк.",
  runSparql: "Выполнить",
  results: "Результаты",
  empty: "По этим условиям ничего не найдено.",
  emptyHint: "Ослабьте год, роль или другой признак и повторите поиск.",
  emptyStart: "Выберите задачу или соберите связи вручную.",
  askTrue: "Истина",
  askFalse: "Ложь",
  downloadCsv: "Скачать CSV",
  downloadJson: "Скачать JSON",
  save: "Сохранить подбор",
  saveCopy: "Сохранить копию",
  update: "Обновить запрос",
  updated: "Запрос обновлён",
  untitled: "Подбор без названия",
  loginToSave: "Войти, чтобы сохранить",
  saveTitle: "Название подбора",
  saved: "Подбор сохранён",
  saveError: "Не удалось сохранить запрос. Условия не потеряны.",
  loadingSaved: "Загрузка сохранённого запроса…",
  savedUnauthorized: "Войдите, чтобы открыть сохранённый запрос.",
  savedNotFound: "Сохранённый запрос не найден.",
  savedLoadError: "Не удалось загрузить сохранённый запрос.",
  savedInvalid: "Сохранённая запись не содержит корректного запроса.",
  restored: "Загружен запрос «{{title}}». Запрос ещё не выполнялся.",
  unbound: "Не задано",
  placeholder: "SELECT ?title ?year WHERE { … } LIMIT 20",
  colTitle: "Название",
  colCreator: "Автор",
  colYear: "Год",
  colPublisher: "Издательство",
  colIdentifier: "ISBN",
  colRecord: "Запись",
  fieldPerson: "Автор / лицо",
  fieldRole: "Роль",
  fieldYearFrom: "Год с",
  fieldYearTo: "Год по",
  fieldLanguage: "Язык",
  fieldPublisher: "Издательство",
  fieldPlace: "Место издания",
  fieldConcept: "Тема / рубрика",
  fieldBbk: "ББК",
  fieldUdc: "УДК",
  fieldIdScheme: "Тип номера",
  fieldIdValue: "Номер",
  fieldPrize: "Премия",
  fieldPrizeYear: "Год / сезон",
  fieldWork: "Произведение",
  languageAny: "Любой",
  languageRus: "русский",
  languageEng: "английский",
  languageDeu: "немецкий",
  languageFra: "французский",
  autocompletePlaceholder: "Начните вводить название",
  autocompleteEmpty: "Ничего не найдено",
  autocompleteLoading: "Поиск…",
  validationRequired: "Заполните это поле",
  validationSubject: "Укажите рубрику, ББК или УДК",
  runErrorBadRequest: "Запрос составлен неверно. Проверьте поля или текст SPARQL.",
  runErrorRateLimit: "Слишком много запросов. Подождите немного и повторите.",
  runErrorTimeout: "Запрос выполнялся слишком долго. Сузьте условия.",
  runErrorUnavailable: "Сервис подбора временно недоступен.",
  roles: {
    author: "автор",
    translator: "переводчик",
    editor: "редактор",
    compiler: "составитель",
  },
  schemes: {
    isbn: "ISBN",
    issn: "ISSN",
    doi: "DOI",
    udc: "УДК",
    bbk: "ББК",
    rsl_reg: "Рег. номер РГБ",
    nbr_bib: "№ записи НБР",
    rsl_bib: "№ записи РГБ",
    nlr_bib: "№ записи РНБ",
  },
  scenarios: {
    author_editions: {
      title: "Издания автора",
      hint: "Найду издания, где выбранное лицо указано в выбранной роли.",
    },
    publisher_editions: {
      title: "Издания издательства",
      hint: "Найду издания выбранной организации за указанные годы.",
    },
    subject: {
      title: "По теме или индексу",
      hint: "Найду издания по рубрике, ББК или УДК.",
    },
    identifier: {
      title: "По номеру",
      hint: "Найду издание по ISBN, ISSN, DOI, УДК, ББК или системному номеру.",
    },
    prize: {
      title: "Лауреаты премии",
      hint: "Найду номинантов и лауреатов выбранной премии.",
    },
    work_editions: {
      title: "Все издания произведения",
      hint: "Найду издания выбранного сочинения.",
    },
  },
}
